
export default {
  name: 'SocialShareButtons',
  props: {
    url: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    containerClass: {
      type: String,
      default: 'd-flex align-items-center',
    },
    buttonsClass: {
      type: String,
      default: 'tw-gap-1',
    },
    collapseOnMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      linkCopied: false,
      canUseNativeShareFlag: false,
    }
  },
  computed: {
    shareUrl() {
      return this.url || this.$config.url + this.$route.fullPath
    },
    shareTitle() {
      return this.title || ''
    },
    encodedUrl() {
      return encodeURIComponent(this.shareUrl)
    },
    encodedTitle() {
      return encodeURIComponent(this.shareTitle)
    },
    encodedDescription() {
      return encodeURIComponent(this.description)
    },
    facebookUrl() {
      return `https://www.facebook.com/sharer/sharer.php?u=${this.encodedUrl}&quote=${this.encodedTitle}%20%23agmvision`
    },
    twitterUrl() {
      return `https://x.com/intent/tweet?url=${this.encodedUrl}&text=${this.encodedTitle}&hashtags=agmvision`
    },
    whatsappUrl() {
      return `https://wa.me/?text=${this.encodedTitle}%20%23agmvision%20${this.encodedUrl}`
    },
    snapchatUrl() {
      return `https://www.snapchat.com/share?url=${this.encodedUrl}`
    },
    canUseNativeShare() {
      return this.canUseNativeShareFlag
    },
    facebookLabel() {
      return this.$t('components.socialShare.facebook')
    },
    twitterLabel() {
      return this.$t('components.socialShare.twitter')
    },
    whatsappLabel() {
      return this.$t('components.socialShare.whatsapp')
    },
    copyLinkLabel() {
      return this.$t('components.socialShare.copyLink')
    },
    nativeShareLabel() {
      return this.$t('components.socialShare.more')
    },
  },
  mounted() {
    this.canUseNativeShareFlag =
      typeof navigator !== 'undefined' && navigator.share !== undefined
  },
  methods: {
    share(platform) {
      const urls = {
        facebook: this.facebookUrl,
        twitter: this.twitterUrl,
        whatsapp: this.whatsappUrl,
        snapchat: this.snapchatUrl,
      }

      const width = 600
      const height = 400
      const left = (window.innerWidth - width) / 2
      const top = (window.innerHeight - height) / 2

      window.open(
        urls[platform],
        `share-${platform}`,
        `width=${width},height=${height},left=${left},top=${top},toolbar=no,menubar=no`
      )

      this.$emit('shared', platform)
    },
    async copyLink() {
      try {
        await navigator.clipboard.writeText(this.shareUrl)
        this.linkCopied = true
        this.$emit('copied')

        setTimeout(() => {
          this.linkCopied = false
        }, 2000)
      } catch (err) {
        const textArea = document.createElement('textarea')
        textArea.value = this.shareUrl
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand('copy')
        document.body.removeChild(textArea)
        this.linkCopied = true

        setTimeout(() => {
          this.linkCopied = false
        }, 2000)
      }
    },
    async nativeShare() {
      if (navigator.share) {
        try {
          await navigator.share({
            title: this.shareTitle,
            text: this.description,
            url: this.shareUrl,
          })
          this.$emit('shared', 'native')
        } catch (err) {
          if (err.name !== 'AbortError') {
            console.error('Error sharing:', err)
          }
        }
      }
    },
  },
}
